enum ProductWarningEnum {
    PROP_65 = "PROP_65",
    VINPOCETINE = "VINPOCETINE",
}

export default ProductWarningEnum;
